import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { GalleriaModule } from 'primeng/galleria';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../../../shared/shared.module';
import { VisitedLinkModule } from '../../ui/visited-link/visited-link.module';
import { CaseFileUploadComponent } from './case-file-upload.component';

@NgModule({
  declarations: [CaseFileUploadComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GalleriaModule,
    DropdownModule,
    TableModule,
    ButtonModule,
    VisitedLinkModule,
  ],
  exports: [CaseFileUploadComponent],
})
export class CaseFileUploadModule {}
